export const infoData = [
  {
    slot: 1,
    key: 'obsidian',
    need: 'Obsidian',
    desc: 'Enhancement (Obsidian) Level',
    info: [
      { level: 1, quantity: 25 },
      { level: 2, quantity: 20 },
      { level: 3, quantity: 30 },
      { level: 4, quantity: 40 },
      { level: 5, quantity: 50 },
      { level: 6, quantity: 70 },
      { level: 7, quantity: 90 },
      { level: 8, quantity: 110 },
      { level: 9, quantity: 130 },
      { level: 10, quantity: 150 },
      { level: 11, quantity: 180 },
      { level: 12, quantity: 210 },
      { level: 13, quantity: 240 },
      { level: 14, quantity: 270 },
      { level: 15, quantity: 300 },
      { level: 16, quantity: 340 },
      { level: 17, quantity: 380 },
      { level: 18, quantity: 420 },
      { level: 19, quantity: 460 },
      { level: 20, quantity: 500 },
      { level: 21, quantity: 550 },
      { level: 22, quantity: 600 },
      { level: 23, quantity: 650 },
      { level: 24, quantity: 700 },
      { level: 25, quantity: 750 },
      { level: 26, quantity: 810 },
      { level: 27, quantity: 870 },
      { level: 28, quantity: 930 },
      { level: 29, quantity: 990 },
      { level: 30, quantity: 1050 }
    ]
  },
  {
    slot: 2,
    key: 'gold-tattoos',
    need: 'Tattoos',
    desc: 'Gold Totem Skill (Tattoos) Level',
    info: [
      { level: 1, quantity: 15 },
      { level: 2, quantity: 25 },
      { level: 3, quantity: 35 },
      { level: 4, quantity: 45 },
      { level: 5, quantity: 55 },
      { level: 6, quantity: 65 },
      { level: 7, quantity: 85 },
      { level: 8, quantity: 95 },
      { level: 9, quantity: 120 },
      { level: 10, quantity: 130 },
      { level: 11, quantity: 170 },
      { level: 12, quantity: 180 },
      { level: 13, quantity: 195 },
      { level: 14, quantity: 205 },
      { level: 15, quantity: 220 },
      { level: 16, quantity: 230 },
      { level: 17, quantity: 265 },
      { level: 18, quantity: 285 },
      { level: 19, quantity: 315 },
      { level: 20, quantity: 335 },
      { level: 21, quantity: 360 },
      { level: 22, quantity: 390 },
      { level: 23, quantity: 440 },
      { level: 24, quantity: 490 },
      { level: 25, quantity: 540 },
      { level: 26, quantity: 590 },
      { level: 27, quantity: 650 },
      { level: 28, quantity: 750 },
      { level: 29, quantity: 850 },
      { level: 30, quantity: 1000 }
    ]
  },
  {
    slot: 2.5,
    key: 'purple-tattoos',
    need: 'Tattoos',
    desc: 'Purple Totem Skill (Tattoos) Level',
    info: [
      { level: 1, quantity: 45 },
      { level: 2, quantity: 55 },
      { level: 3, quantity: 96 },
      { level: 4, quantity: 105 },
      { level: 5, quantity: 145 },
      { level: 6, quantity: 155 },
      { level: 7, quantity: 205 },
      { level: 8, quantity: 220 },
      { level: 9, quantity: 265 },
      { level: 10, quantity: 285 },
      { level: 11, quantity: 390 },
      { level: 12, quantity: 410 },
      { level: 13, quantity: 440 },
      { level: 14, quantity: 460 },
      { level: 15, quantity: 490 },
      { level: 16, quantity: 510 },
      { level: 17, quantity: 515 },
      { level: 18, quantity: 535 },
      { level: 19, quantity: 540 },
      { level: 20, quantity: 560 },
      { level: 21, quantity: 590 },
      { level: 22, quantity: 620 },
      { level: 23, quantity: 650 },
      { level: 24, quantity: 680 },
      { level: 25, quantity: 0 },
      { level: 26, quantity: 0 },
      { level: 27, quantity: 0 },
      { level: 28, quantity: 0 },
      { level: 29, quantity: 0 },
      { level: 30, quantity: 0 }
    ]
  },
  {
    slot: 2.5,
    key: 'blue-tattoos',
    need: 'Tattoos',
    desc: 'Blue Totem Skill (Tattoos) Level',
    info: [
      { level: 1, quantity: 150 },
      { level: 2, quantity: 175 },
      { level: 3, quantity: 200 },
      { level: 4, quantity: 225 },
      { level: 5, quantity: 250 },
      { level: 6, quantity: 350 },
      { level: 7, quantity: 425 },
      { level: 8, quantity: 550 },
      { level: 9, quantity: 625 },
      { level: 10, quantity: 700 }
    ]
  },
  {
    slot: 3,
    key: 'vip-levels',
    need: 'VIP Points',
    desc: 'VIP / SVIP Level',
    info: [
      { level: 2, quantity: 380 },
      { level: 3, quantity: 1880 },
      { level: 4, quantity: 6380 },
      { level: 5, quantity: 15380 },
      { level: 6, quantity: 30380 },
      { level: 7, quantity: 60380 },
      { level: 8, quantity: 120380 },
      { level: 9, quantity: 230380 },
      { level: 10, quantity: 440380 },
      { level: 11, quantity: 780380 },
      { level: 12, quantity: 1280610 },
      { level: 'SVIP1', quantity: '15 points', info: 'Meele HP % (20 MAX)', extraQuantity: 376000 },
      { level: 'SVIP2', quantity: '50 points', info: 'Ranged Attack % (20 MAX)', extraQuantity: 413600 },
      { level: 'SVIP3', quantity: '100 points', info: 'Elite War Attack and HP % (30 MAX)', extraQuantity: 451200 },
      { level: 'SVIP4', quantity: '300 points', info: 'Invasion Attack and HP % (30 MAX)', extraQuantity: 451200 },
      { level: 'SVIP5', quantity: '600 points', info: 'Elite War Damage % (20 MAX)', extraQuantity: 488800 },
      { level: 'SVIP6', quantity: '1200 points', info: 'Invasion Damage % (20 MAX)', extraQuantity: 488800 }
    ]
  },
  {
    slot: 4,
    key: 'emblems',
    need: 'Emblem Shards',
    desc: 'Emblem Level',
    info: [
      { level: 2, quantity: 2 },
      { level: 3, quantity: 3 },
      { level: 4, quantity: 4 },
      { level: 5, quantity: 6 },
      { level: 6, quantity: 8 },
      { level: 7, quantity: 10 },
      { level: 8, quantity: 12 },
      { level: 9, quantity: 14 },
      { level: 10, quantity: 16 },
      { level: 11, quantity: 18 },
      { level: 12, quantity: 20 },
      { level: 13, quantity: 22 },
      { level: 14, quantity: 24 },
      { level: 15, quantity: 26 },
      { level: 16, quantity: 28 },
      { level: 17, quantity: 30 },
      { level: 18, quantity: 32 },
      { level: 19, quantity: 35 },
      { level: 20, quantity: 38 },
      { level: 21, quantity: 41 },
      { level: 22, quantity: 44 },
      { level: 23, quantity: 47 },
      { level: 24, quantity: 50 },
      { level: 25, quantity: 54 },
      { level: 26, quantity: 64 },
      { level: 27, quantity: 79 },
      { level: 28, quantity: 99 },
      { level: 29, quantity: 124 },
      { level: 30, quantity: 154 }
    ]
  },
  {
    slot: 5,
    key: 'beast-skill',
    need: 'Experience',
    desc: 'Beast Passive Skill',
    info: [
      { level: 2, quantity: 150 },
      { level: 3, quantity: 250 },
      { level: 4, quantity: 300 },
      { level: 5, quantity: 400 },
      { level: 6, quantity: 500 },
      { level: 7, quantity: 600 },
      { level: 8, quantity: 750 },
      { level: 9, quantity: 900 },
      { level: 10, quantity: 1350 },
      { level: 11, quantity: 1650 },
      { level: 12, quantity: 2000 },
      { level: 13, quantity: 2400 },
      { level: 14, quantity: 2900 },
      { level: 15, quantity: 4350 },
      { level: 16, quantity: 5250 },
      { level: 17, quantity: 6300 },
      { level: 18, quantity: 7600 },
      { level: 19, quantity: 9150 },
      { level: 20, quantity: 11000 },
      { level: 21, quantity: 13200 },
      { level: 22, quantity: 15850 },
      { level: 23, quantity: 19500 },
      { level: 24, quantity: 24900 },
      { level: 25, quantity: 33500 },
      { level: 26, quantity: 45500 },
      { level: 27, quantity: 50350 },
      { level: 28, quantity: 53000 },
      { level: 29, quantity: 55600 },
      { level: 30, quantity: 61250 }
    ]
  },
  {
    slot: 6,
    key: 'beaxt-exp',
    need: 'Experience Pills',
    desc: 'Beast Experience',
    info: [
      { level: 2, quantity: 1600 },
      { level: 3, quantity: 2800 },
      { level: 4, quantity: 3600 },
      { level: 5, quantity: 4400 },
      { level: 6, quantity: 6600 },
      { level: 7, quantity: 8000 },
      { level: 8, quantity: 12000 },
      { level: 9, quantity: 18000 },
      { level: 10, quantity: 21600 },
      { level: 11, quantity: 32400 },
      { level: 12, quantity: 48600 },
      { level: 13, quantity: 58400 },
      { level: 14, quantity: 70100 },
      { level: 15, quantity: 98200 },
      { level: 16, quantity: 117900 },
      { level: 17, quantity: 141500 },
      { level: 18, quantity: 184000 },
      { level: 19, quantity: 220800 },
      { level: 20, quantity: 265000 },
      { level: 21, quantity: 344500 },
      { level: 22, quantity: 413400 },
      { level: 23, quantity: 496100 },
      { level: 24, quantity: 536630 },
      { level: 25, quantity: 721500 },
      { level: 26, quantity: 843200 },
      { level: 27, quantity: 946900 },
      { level: 28, quantity: 1059600 },
      { level: 29, quantity: 1172300 },
      { level: 30, quantity: 1285000 },
      { level: 31, quantity: 1397700 },
      { level: 32, quantity: 1510400 },
      { level: 33, quantity: 1623100 },
      { level: 34, quantity: 1735800 },
      { level: 35, quantity: 1848500 }
    ]
  },
  {
    slot: 7,
    key: 'blue-artifact-exp',
    need: 'Experience',
    desc: 'Blue Artifact Experience',
    info: [
      { level: 1, quantity: 0 },
      { level: 2, quantity: 30 },
      { level: 3, quantity: 70 },
      { level: 4, quantity: 130 },
      { level: 5, quantity: 260 },
      { level: 6, quantity: 420 },
      { level: 7, quantity: 640 },
      { level: 8, quantity: 900 },
      { level: 9, quantity: 1350 },
      { level: 10, quantity: 1950 },
      { level: 11, quantity: 2700 },
      { level: 12, quantity: 4050 },
      { level: 13, quantity: 5850 },
      { level: 14, quantity: 7880 },
      { level: 15, quantity: 10500 },
      { level: 16, quantity: 13800 },
      { level: 17, quantity: 17130 },
      { level: 18, quantity: 20610 },
      { level: 19, quantity: 24200 },
      { level: 20, quantity: 27920 },
      { level: 21, quantity: 31920 },
      { level: 22, quantity: 36050 },
      { level: 23, quantity: 40300 },
      { level: 24, quantity: 44600 },
      { level: 25, quantity: 49050 },
      { level: 26, quantity: 53610 },
      { level: 27, quantity: 58290 },
      { level: 28, quantity: 63090 },
      { level: 29, quantity: 68010 },
      { level: 30, quantity: 73050 }
    ]
  },
  {
    slot: 8,
    key: 'purple-artifact-exp',
    need: 'Experience',
    desc: 'Purple Artifact Experience',
    info: [
      { level: 1, quantity: 0 },
      { level: 2, quantity: 40 },
      { level: 3, quantity: 80 },
      { level: 4, quantity: 150 },
      { level: 5, quantity: 290 },
      { level: 6, quantity: 480 },
      { level: 7, quantity: 720 },
      { level: 8, quantity: 1020 },
      { level: 9, quantity: 1530 },
      { level: 10, quantity: 2210 },
      { level: 11, quantity: 3600 },
      { level: 12, quantity: 4590 },
      { level: 13, quantity: 6630 },
      { level: 14, quantity: 8920 },
      { level: 15, quantity: 11900 },
      { level: 16, quantity: 15600 },
      { level: 17, quantity: 19500 },
      { level: 18, quantity: 23400 },
      { level: 19, quantity: 27500 },
      { level: 20, quantity: 31700 },
      { level: 21, quantity: 36200 },
      { level: 22, quantity: 40900 },
      { level: 23, quantity: 45650 },
      { level: 24, quantity: 50550 },
      { level: 25, quantity: 55590 },
      { level: 26, quantity: 60800 },
      { level: 27, quantity: 66100 },
      { level: 28, quantity: 71500 },
      { level: 29, quantity: 77100 },
      { level: 30, quantity: 82800 },
      { level: 31, quantity: 88700 },
      { level: 32, quantity: 94700 },
      { level: 33, quantity: 100000 },
      { level: 34, quantity: 107000 },
      { level: 35, quantity: 113600 },
      { level: 36, quantity: 120200 },
      { level: 37, quantity: 127000 },
      { level: 38, quantity: 134000 },
      { level: 39, quantity: 141000 },
      { level: 40, quantity: 148500 }
    ]
  },
  {
    slot: 9,
    key: 'gold-artifact-exp',
    need: 'Experience',
    desc: 'Gold Artifact Experience',
    info: [
      { level: 1, quantity: 0 },
      { level: 2, quantity: 50 },
      { level: 3, quantity: 100 },
      { level: 4, quantity: 180 },
      { level: 5, quantity: 340 },
      { level: 6, quantity: 560 },
      { level: 7, quantity: 850 },
      { level: 8, quantity: 1200 },
      { level: 9, quantity: 1800 },
      { level: 10, quantity: 2600 },
      { level: 11, quantity: 3600 },
      { level: 12, quantity: 5400 },
      { level: 13, quantity: 7800 },
      { level: 14, quantity: 10500 },
      { level: 15, quantity: 14010 },
      { level: 16, quantity: 18350 },
      { level: 17, quantity: 22840 },
      { level: 18, quantity: 27480 },
      { level: 19, quantity: 32270 },
      { level: 20, quantity: 37220 },
      { level: 21, quantity: 42570 },
      { level: 22, quantity: 48060 },
      { level: 23, quantity: 53690 },
      { level: 24, quantity: 59470 },
      { level: 25, quantity: 65400 },
      { level: 26, quantity: 71480 },
      { level: 27, quantity: 77720 },
      { level: 28, quantity: 84120 },
      { level: 29, quantity: 90680 },
      { level: 30, quantity: 97400 },
      { level: 31, quantity: 104290 },
      { level: 32, quantity: 111350 },
      { level: 33, quantity: 118590 },
      { level: 34, quantity: 126010 },
      { level: 35, quantity: 133610 },
      { level: 36, quantity: 141400 },
      { level: 37, quantity: 149380 },
      { level: 38, quantity: 157550 },
      { level: 39, quantity: 165920 },
      { level: 40, quantity: 174490 },
      { level: 41, quantity: 183260 },
      { level: 42, quantity: 192240 },
      { level: 43, quantity: 201440 },
      { level: 44, quantity: 210850 },
      { level: 45, quantity: 220490 },
      { level: 46, quantity: 230350 },
      { level: 47, quantity: 240450 },
      { level: 48, quantity: 250780 },
      { level: 49, quantity: 261350 },
      { level: 50, quantity: 272170 }
    ]
  },
  {
    slot: 10,
    key: 'lord-exp',
    need: 'Lord Exp',
    desc: 'Lord Level',
    info: [
      { level: 1, quantity: 0, info: '0 Skill Points' },
      { level: 2, quantity: 30, info: '3 Skill Points' },
      { level: 3, quantity: 120, info: '3 Skill Points' },
      { level: 4, quantity: 300, info: '3 Skill Points' },
      { level: 5, quantity: 500, info: '3 Skill Points' },
      { level: 6, quantity: 1000, info: '3 Skill Points' },
      { level: 7, quantity: 1800, info: '3 Skill Points' },
      { level: 8, quantity: 2900, info: '3 Skill Points' },
      { level: 9, quantity: 4300, info: '3 Skill Points' },
      { level: 10, quantity: 6000, info: '4 Skill Points' },
      { level: 11, quantity: 11400, info: '4 Skill Points' },
      { level: 12, quantity: 14000, info: '4 Skill Points' },
      { level: 13, quantity: 17300, info: '4 Skill Points' },
      { level: 14, quantity: 28000, info: '4 Skill Points' },
      { level: 15, quantity: 33700, info: '4 Skill Points' },
      { level: 16, quantity: 49900, info: '4 Skill Points' },
      { level: 17, quantity: 70600, info: '4 Skill Points' },
      { level: 18, quantity: 95900, info: '4 Skill Points' },
      { level: 19, quantity: 127600, info: '4 Skill Points' },
      { level: 20, quantity: 165100, info: '5 Skill Points' },
      { level: 21, quantity: 210800, info: '5 Skill Points' },
      { level: 22, quantity: 266200, info: '5 Skill Points' },
      { level: 23, quantity: 333000, info: '5 Skill Points' },
      { level: 24, quantity: 413300, info: '5 Skill Points' },
      { level: 25, quantity: 509500, info: '5 Skill Points' },
      { level: 26, quantity: 624200, info: '5 Skill Points' },
      { level: 27, quantity: 752600, info: '5 Skill Points' },
      { level: 28, quantity: 895900, info: '5 Skill Points' },
      { level: 29, quantity: 1054900, info: '5 Skill Points' },
      { level: 30, quantity: 1230200, info: '6 Skill Points' },
      { level: 31, quantity: 1422700, info: '6 Skill Points' },
      { level: 32, quantity: 1633000, info: '6 Skill Points' },
      { level: 33, quantity: 1816300, info: '6 Skill Points' },
      { level: 34, quantity: 2009300, info: '6 Skill Points' },
      { level: 35, quantity: 2211800, info: '6 Skill Points - SOS Unlocked' },
      { level: 36, quantity: 2424000, info: '6 Skill Points' },
      { level: 37, quantity: 2645800, info: '6 Skill Points' },
      { level: 38, quantity: 2983700, info: '6 Skill Points' },
      { level: 39, quantity: 3340800, info: '6 Skill Points' },
      { level: 40, quantity: 3717100, info: '7 Skill Points' },
      { level: 41, quantity: 4112600, info: '7 Skill Points' },
      { level: 42, quantity: 4527400, info: '7 Skill Points' },
      { level: 43, quantity: 4961300, info: '7 Skill Points' },
      { level: 44, quantity: 5614400, info: '7 Skill Points - Slaughter Unlocked' },
      { level: 45, quantity: 6186700, info: '7 Skill Points' },
      { level: 46, quantity: 6778200, info: '7 Skill Points' },
      { level: 47, quantity: 7389000, info: '7 Skill Points' },
      { level: 48, quantity: 8018900, info: '7 Skill Points' },
      { level: 49, quantity: 8668000, info: '7 Skill Points' },
      { level: 50, quantity: 9336300, info: '7 Skill Points' },
      { level: 51, quantity: 9999999, info: '8 Skill Points' },
      { level: 52, quantity: 10425600, info: '8 Skill Points' },
      { level: 53, quantity: 11070700, info: '8 Skill Points' },
      { level: 54, quantity: 11735000, info: '8 Skill Points' },
      { level: 55, quantity: 12418600, info: '8 Skill Points' },
      { level: 56, quantity: 13121300, info: '8 Skill Points' },
      { level: 57, quantity: 13843200, info: '8 Skill Points' },
      { level: 58, quantity: 14584300, info: '8 Skill Points' },
      { level: 59, quantity: 15344600, info: '8 Skill Points' },
      { level: 60, quantity: 16124200, info: '8 Skill Points' },
      { level: 61, quantity: 16922900, info: '8 Skill Points' },
      { level: 62, quantity: 17728700, info: '8 Skill Points' },
      { level: 63, quantity: 18545600, info: '8 Skill Points' },
      { level: 64, quantity: 19371700, info: '8 Skill Points' },
      { level: 65, quantity: 20204800, info: '8 Skill Points' },
      { level: 66, quantity: 21002800, info: '8 Skill Points' },
      { level: 67, quantity: 21882800, info: '8 Skill Points' },
      { level: 68, quantity: 22722800, info: '8 Skill Points' },
      { level: 69, quantity: 23922800, info: '8 Skill Points' },
      { level: 70, quantity: 25000000, info: '8 Skill Points' }
    ]
  },
  {
    slot: 11,
    key: 'hall-war',
    need: 'Glory Swords',
    desc: 'Hall of War Level',
    info: [
      { level: 1, quantity: 2, info: 'Rally Size: 50,000' },
      { level: 2, quantity: 8, info: 'Rally Size: 60,000' },
      { level: 3, quantity: 17, info: 'Rally Size: 70,000' },
      { level: 4, quantity: 29, info: 'Rally Size: 82,000' },
      { level: 5, quantity: 44, info: 'Rally Size: 96,000' },
      { level: 6, quantity: 63, info: 'Rally Size: 112,000' },
      { level: 7, quantity: 86, info: 'Rally Size: 130,000' },
      { level: 8, quantity: 113, info: 'Rally Size: 150,000' },
      { level: 9, quantity: 145, info: 'Rally Size: 172,000' },
      { level: 10, quantity: 182, info: 'Rally Size: 196,000' },
      { level: 11, quantity: 224, info: 'Rally Size: 222,000' },
      { level: 12, quantity: 272, info: 'Rally Size: 250,000' },
      { level: 13, quantity: 326, info: 'Rally Size: 280,000' },
      { level: 14, quantity: 386, info: 'Rally Size: 312,000' },
      { level: 15, quantity: 452, info: 'Rally Size: 346,000' },
      { level: 16, quantity: 524, info: 'Rally Size: 382,000' },
      { level: 17, quantity: 603, info: 'Rally Size: 422,000' },
      { level: 18, quantity: 689, info: 'Rally Size: 460,000' },
      { level: 19, quantity: 782, info: 'Rally Size: 502,000' },
      { level: 20, quantity: 882, info: 'Rally Size: 546,000' },
      { level: 21, quantity: 989, info: 'Rally Size: 592,000' },
      { level: 22, quantity: 1104, info: 'Rally Size: 640,000' },
      { level: 23, quantity: 1227, info: 'Rally Size: 690,000' },
      { level: 24, quantity: 1358, info: 'Rally Size: 742,000' },
      { level: 25, quantity: 1497, info: 'Rally Size: 796,000' },
      { level: 26, quantity: 1645, info: 'Rally Size: 852,000' },
      { level: 27, quantity: 1802, info: 'Rally Size: 910,000' },
      { level: 28, quantity: 1968, info: 'Rally Size: 970,000' },
      { level: 29, quantity: 2143, info: 'Rally Size: 1,032,000' },
      { level: 30, quantity: 2327, info: 'Rally Size: 1,096,000' },
      { level: 31, quantity: 2631, info: 'Rally Size: 1,162,000' },
      { level: 32, quantity: 3095, info: 'Rally Size: 1,230,000' },
      { level: 33, quantity: 3659, info: 'Rally Size: 1,300,000' },
      { level: 34, quantity: 4464, info: 'Rally Size: 1,382,000' },
      { level: 35, quantity: 5347, info: 'Rally Size: 1,446,000' },
      { level: 36, quantity: 5470, info: 'Rally Size: 1,526,000' },
      { level: 37, quantity: 5830, info: 'Rally Size: 1,616,000' },
      { level: 38, quantity: 6260, info: 'Rally Size: 1,716,000' },
      { level: 39, quantity: 6680, info: 'Rally Size: 1,826,000' },
      { level: 40, quantity: 7000, info: 'Rally Size: 1,946,000' }
    ]
  },
  {
    slot: 12,
    key: 'colossus-crystals',
    need: 'Crystals',
    desc: 'Colossus Crystal',
    info: [
      { level: 1, quantity: 5 },
      { level: 2, quantity: 10 },
      { level: 3, quantity: 25 },
      { level: 4, quantity: 45 },
      { level: 5, quantity: 65 },
      { level: 6, quantity: 120, ar: 15 },
      { level: 7, quantity: 160 },
      { level: 8, quantity: 200 },
      { level: 9, quantity: 240 },
      { level: 10, quantity: 280 },
      { level: 11, quantity: 700, ar: 120 },
      { level: 12, quantity: 850 },
      { level: 13, quantity: 1000 },
      { level: 14, quantity: 1150 },
      { level: 15, quantity: 1300 },
      { level: 16, quantity: 1650, ar: 380 },
      { level: 17, quantity: 1850 },
      { level: 18, quantity: 2050 },
      { level: 19, quantity: 2250 },
      { level: 20, quantity: 2450 },
      { level: 21, quantity: 2600, ar: 740 },
      { level: 22, quantity: 2800 },
      { level: 23, quantity: 3000 },
      { level: 24, quantity: 3200 },
      { level: 25, quantity: 3400 }
    ]
  },
  {
    slot: 13,
    key: 'colossus-relics',
    need: 'Relics',
    desc: 'Colossus Relic',
    info: [
      { level: 5, quantity: 15 },
      { level: 10, quantity: 120 },
      { level: 15, quantity: 380 },
      { level: 20, quantity: 740 }
    ]
  },
  {
    slot: 14,
    key: 'merit-ranks',
    need: 'Merit',
    desc: 'Merit Ranks',
    info: [
      { level: 'Sargeant', quantity: 200, info: 'Wounded %: 1.50' },
      { level: 'Sergant Major', quantity: 700, info: 'Wounded %: 3 - Wounded Limit: 4,000' },
      { level: 'Liutenant Knight', quantity: 1800, info: 'Wounded %: 4.50 - Wounded Limit: 8,000 - Army Limit: 3,500' },
      { level: 'Centurion', quantity: 4000, info: 'Wounded %: 6 - Wounded Limit: 12,000 - Army Limit: 7,000' },
      {
        level: 'Sriker Battalion',
        quantity: 9000,
        info: 'Wounded %: 7.50 - Wounded Limit: 16,000 - Army Limit: 10,500'
      },
      { level: 'Legion Officer', quantity: 15000, info: 'Wounded %: 9 - Wounded Limit: 20,000 - Army Limit: 14,000' },
      {
        level: 'Legion Commander',
        quantity: 23000,
        info: 'Wounded %: 10.50 - Wounded Limit: 24,000 - Army Limit: 17,500'
      },
      { level: 'High Commander', quantity: 32000, info: 'Wounded %: 12 - Wounded Limit: 28,000 - Army Limit: 21,000' },
      {
        level: 'Royal Commander',
        quantity: 45000,
        info: 'Wounded %: 13.50 - Wounded Limit: 32,000 - Army Limit: 24,500'
      },
      { level: 'Captain', quantity: 60000, info: 'Wounded %: 15 - Wounded Limit: 36,000 - Army Limit: 28,000' },
      { level: 'General', quantity: 78000, info: 'Wounded %: 16.50 - Wounded Limit: 40,000 - Army Limit: 31,500' },
      {
        level: 'Commander-in-Chief',
        quantity: 100000,
        info: 'Wounded %: 18 - Wounded Limit: 44,000 - Army Limit: 31,500'
      },
      { level: 'Overseer', quantity: 135000, info: 'Wounded %: 19.50 - Wounded Limit: 48,000 - Army Limit: 38,500' },
      { level: 'Grand Marshal', quantity: 180000, info: 'Wounded %: 21 - Wounded Limit: 52,000 - Army Limit: 42,000' },
      {
        level: 'Star Marshal',
        quantity: 240000,
        info: 'Wounded %: 22.50 - Wounded Limit: 56,000 - Army Limit: 45,500'
      },
      {
        level: 'Legendary Marshal',
        quantity: 360000,
        info: 'Wounded %: 24 - Wounded Limit: 60,000 - Army Limit: 49,000'
      },
      { level: 'War Lord', quantity: 480000, info: 'Wounded %: 25.50 - Wounded Limit: 64,000 - Army Limit: 52,500' }
    ]
  },
  {
    slot: 15,
    key: 'beast-skin-dark',
    need: 'Shards',
    desc: 'Dark Beast Skin',
    info: [
      { level: 1, quantity: 80, info: 'Critical Strike Dmg Red: 2.2% + Angel Limit: 300' },
      { level: 2, quantity: 80, info: 'Critical Strike Dmg Red: 2.5% + Angel Limit: 300' },
      { level: 3, quantity: 80, info: 'Critical Strike Dmg Red: 2.5% + Angel Limit: 450' },
      { level: 4, quantity: 80, info: 'Critical Strike Dmg Red: 2.8% + Angel Limit: 450' },
      { level: 5, quantity: 100, info: 'Critical Strike Dmg Red: 2.8% + Angel Limit: 600' },
      { level: 6, quantity: 100, info: 'Critical Strike Dmg Red: 3.3% + Angel Limit: 600' },
      { level: 7, quantity: 120, info: 'Critical Strike Dmg Red: 3.3% + Angel Limit: 750' },
      { level: 8, quantity: 120, info: 'Critical Strike Dmg Red: 3.8% + Angel Limit: 750' },
      { level: 9, quantity: 140, info: 'Critical Strike Dmg Red: 3.8% + Angel Limit: 900' },
      { level: 10, quantity: 0, info: 'Critical Strike Dmg Red: 4.3% + Angel Limit: 900' },
      { level: 11, quantity: 0, info: 'Critical Strike Dmg Red: 4.3% + Angel Limit: 1050' },
      { level: 12, quantity: 0, info: 'Critical Strike Dmg Red: 4.9% + Angel Limit: 1050' },
      { level: 13, quantity: 0, info: 'Critical Strike Dmg Red: 4.9% + Angel Limit: 1200' },
      { level: 14, quantity: 0, info: 'Critical Strike Dmg Red: 5.4% + Angel Limit: 1200' },
      { level: 15, quantity: 0, info: 'Critical Strike Dmg Red: 5.4% + Angel Limit: 1400' },
      { level: 16, quantity: 0, info: 'Critical Strike Dmg Red: 6% + Angel Limit: 1400' }
    ]
  },
  {
    slot: 16,
    key: 'pony-event-exp',
    need: 'Experience',
    desc: 'Pony Levels',
    info: [
      { level: 1, quantity: 0, info: '' },
      { level: 2, quantity: 200, info: '' },
      { level: 3, quantity: 300, info: '' },
      { level: 4, quantity: 400, info: '' },
      { level: 5, quantity: 500, info: '' },
      { level: 6, quantity: 600, info: '' },
      { level: 7, quantity: 700, info: '' },
      { level: 8, quantity: 800, info: '' },
      { level: 9, quantity: 900, info: '' },
      { level: 10, quantity: 1000, info: '' },
      { level: 11, quantity: 1150, info: '' },
      { level: 12, quantity: 1300, info: '' },
      { level: 13, quantity: 1450, info: '' },
      { level: 14, quantity: 1600, info: '' },
      { level: 15, quantity: 1750, info: '' },
      { level: 16, quantity: 1900, info: '' },
      { level: 17, quantity: 2050, info: '' },
      { level: 18, quantity: 2350, info: '' },
      { level: 19, quantity: 2550, info: '' },
      { level: 20, quantity: 2750, info: '' },
      { level: 21, quantity: 3000, info: '' },
      { level: 22, quantity: 3250, info: '' },
      { level: 23, quantity: 3500, info: '' },
      { level: 24, quantity: 4000, info: '' },
      { level: 25, quantity: 4300, info: '' },
      { level: 26, quantity: 4600, info: '' },
      { level: 27, quantity: 5000, info: '' },
      { level: 28, quantity: 5400, info: '' },
      { level: 29, quantity: 5900, info: '' },
      { level: 30, quantity: 6400, info: '' },
      { level: 31, quantity: 7000, info: '' },
      { level: 32, quantity: 7600, info: '' },
      { level: 33, quantity: 8300, info: '' },
      { level: 34, quantity: 9000, info: '' },
      { level: 35, quantity: 9800, info: '' },
      { level: 36, quantity: 10600, info: '' },
      { level: 37, quantity: 11500, info: '' },
      { level: 38, quantity: 12400, info: '' },
      { level: 39, quantity: 13400, info: '' },
      { level: 40, quantity: 14400, info: '' },
      { level: 41, quantity: 15400, info: '' },
      { level: 42, quantity: 16400, info: '' },
      { level: 43, quantity: 17400, info: '' },
      { level: 44, quantity: 18400, info: '' },
      { level: 45, quantity: 19400, info: '' },
      { level: 46, quantity: 20400, info: '' },
      { level: 47, quantity: 21400, info: '' },
      { level: 48, quantity: 22400, info: '' },
      { level: 49, quantity: 23400, info: '' },
      { level: 50, quantity: 24400, info: '' },
      { level: 51, quantity: 25900, info: '' },
      { level: 52, quantity: 27400, info: '' },
      { level: 53, quantity: 29400, info: '' }
    ]
  },
  {
    slot: 17,
    key: 'force-array-levels',
    need: 'Star Power',
    desc: 'Artifact Array Levels',
    info: [
      { level: 1, quantity: 200, info: '' },
      { level: 2, quantity: 250, info: '' },
      { level: 3, quantity: 300, info: '' },
      { level: 4, quantity: 400, info: '' },
      { level: 5, quantity: 500, info: '' },
      { level: 6, quantity: 600, info: '' },
      { level: 7, quantity: 750, info: '' },
      { level: 8, quantity: 900, info: '' },
      { level: 9, quantity: 1050, info: '' },
      { level: 10, quantity: 1200, info: '' },
      { level: 11, quantity: 1400, info: '' },
      { level: 12, quantity: 1600, info: '' },
      { level: 13, quantity: 1800, info: '' },
      { level: 14, quantity: 2000, info: '' },
      { level: 15, quantity: 2200, info: '' }
    ]
  },
  {
    slot: 18,
    key: 'star-source',
    need: 'Star Source',
    desc: 'Star Palace / Zodiac Levels',
    info: [
      { level: 1, quantity: 3000, info: '' },
      { level: 2, quantity: 4000, info: '' },
      { level: 3, quantity: 5000, info: 'Evolve Birthstones for next tier: 60' },
      { level: 4, quantity: 7000, info: '' },
      { level: 5, quantity: 10000, info: '' },
      { level: 6, quantity: 13000, info: 'Evolve Birthstones for next tier: 120' },
      { level: 7, quantity: 19000, info: '' },
      { level: 8, quantity: 27000, info: '' },
      { level: 9, quantity: 35000, info: 'Evolve Birthstones for next tier: 240' },
      { level: 10, quantity: 45000, info: '' },
      { level: 11, quantity: 57000, info: '' },
      { level: 12, quantity: 69000, info: 'Evolve Birthstones for next tier: 480' },
      { level: 13, quantity: 75000, info: '' },
      { level: 14, quantity: 90000, info: '' },
      { level: 15, quantity: 105000, info: '' }
    ]
  },
  {
    slot: 19,
    key: 'force-red-skill',
    need: 'Star Power',
    desc: 'Red Force Artifact Levels',
    info: [
      { level: 1, quantity: 2000, info: 'Artifact 3 Stars Needed' },
      { level: 2, quantity: 3000, info: 'Artifact 5 Stars Needed' },
      { level: 3, quantity: 4000, info: 'Artifact 6 Stars Needed' }
    ]
  },
  {
    slot: 20,
    key: 'crown-red-skill',
    need: 'Star Power',
    desc: 'Red Crown Artifact Levels',
    info: [
      { level: 1, quantity: 2500, info: 'Artifact 3 Stars Needed' },
      { level: 2, quantity: 3500, info: 'Artifact 5 Stars Needed' },
      { level: 3, quantity: 4500, info: 'Artifact 6 Stars Needed' }
    ]
  },
  {
    slot: 21,
    key: 'gold-artifact-shards',
    need: 'Shards',
    desc: 'Gold Artifacts Shards',
    info: [
      { level: '1', quantity: 20, info: '20' },
      { level: '2', quantity: 80, info: '80' },
      { level: '2 Rank 1', quantity: 80, info: '' },
      { level: '3', quantity: 80, info: '160' },
      { level: '3 Rank 1', quantity: 93, info: '' },
      { level: '3 Rank 2', quantity: 93, info: '' },
      { level: '4', quantity: 93, info: '279' },
      { level: '4 Rank 1', quantity: 115, info: '' },
      { level: '4 Rank 2', quantity: 115, info: '' },
      { level: '4 Rank 3', quantity: 115, info: '' },
      { level: '5', quantity: 115, info: '460' },
      { level: '5 Rank 1', quantity: 140, info: '' },
      { level: '5 Rank 2', quantity: 140, info: '' },
      { level: '5 Rank 3', quantity: 140, info: '' },
      { level: '5 Rank 4', quantity: 140, info: '' },
      { level: '6', quantity: 140, info: '700' }
    ]
  },
  {
    slot: 22,
    key: 'angel-limit',
    need: 'Limit ',
    desc: 'Angel Limit',
    info: [
      { level: 'Enhancement - Belt', quantity: 4025, info: '' },
      { level: 'Enhancement - Accessory', quantity: 4025, info: '' },
      { level: 'Gear - Sage Belt', quantity: 2600, info: '' },
      { level: 'Gear - Royal Crown', quantity: 2200, info: '' },
      { level: 'Angel Sword 6*', quantity: 5800, info: '' },
      { level: 'Guardian Temple - Lv8+', quantity: 70000, info: '' },
      { level: 'Guardian Temple - lv12+', quantity: 15000, info: '' },
      { level: 'Emblem - Guard Lv30', quantity: 38500, info: '' },
      { level: 'Beast Skin - Dark Star', quantity: 1400, info: '' }
    ]
  }
]
